import { jsx as _jsx } from "react/jsx-runtime";
import DomPurify from "isomorphic-dompurify";
import styles from "./ReferralPersonalCode.module.scss";
const { sanitize } = DomPurify;
export const ReferralPersonalCodeSmallText = ({ isWithBackgroundImageVariant, smallText, }) => {
    if (!smallText || !isWithBackgroundImageVariant) {
        return null;
    }
    return (_jsx("div", { "data-testid": "referral-personal-code__small-text", className: styles.smallText, dangerouslySetInnerHTML: {
            __html: sanitize(smallText),
        } }));
};
//# sourceMappingURL=ReferralPersonalCodeSmallText.js.map